<script type="text/javascript">

  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        editor_type: 'doc',
        editing: {},

        default_content: {
          type: 'grid',
          title: 'Custom content',
          active: 1,
          full_width: 1,
          image: '',
          color: '',
          opacity: '',
          pad_t: '',
          pad_r: '',
          pad_b: '',
          pad_l: '',
          columns: [
            {
              image: '',
              color: '',
              opacity: '',
              pad_t: '',
              pad_r: '',
              pad_b: '',
              pad_l: '',
              width: '6',
              content: '',
            },
            {
              image: '',
              color: '',
              opacity: '',
              pad_t: '',
              pad_r: '',
              pad_b: '',
              pad_l: '',
              width: '6',
              content: '',
            },
          ],
        },
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.columns) { this.pc.columns = []; this.$forceUpdate(); }
    },
    methods: {
      delete_content(col_i) {
        if(!this.pc.columns[col_i]) { this.$noty.warning('<i class="far fa-bell mr-1"></i> ID not found'); return; }
        var n = this.$noty.error('<div>Are you sure you want to delete this content? This action cannot be undone.</div>', { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
          buttons: [
            Noty.button('YES', 'btn btn-block btn-light', res => {
              this.pc.columns.splice(col_i, 1);
              this.$noty.success("Content removed");
              this.$forceUpdate();
              n.close();
            }, {id: 'button1', 'data-status': 'ok'}),
          ]
        }).on('onClose', () => { });
      },
      changeEditor(type) {
        var n = this.$noty.error('<div class="p-3"><h3 class="text-white">Are you sure you would like to change editors?</h3><div>Changing the content type can cause data to be lost, specifically when changing to the Document editor as all data will be parsed.</div></div>', { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
          buttons: [
            Noty.button('YES', 'btn btn-block btn-light', res => {
              this.editing.editor = type;
              this.$forceUpdate();
              n.close();
            }, {id: 'button1', 'data-status': 'ok'}),
          ]
        }).on('onClose', () => { });
      },
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">

      <b-modal ref="modal_edit_column" centered size="xl" title="Edit column" :hide-footer="true" :no-enforce-focus="true">
        <div class="p-3">
          <div class="row">
            <div class="col-sm-4">
              <w-field SimpleDataType="String" v-model="editing.image" Title="Background image URL :"></w-field>
            </div>
            <div class="col-sm-4">
              <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="editing.color"></w-field>
            </div>
            <div class="col-sm-4">
              <w-field SimpleDataType="Number" v-model="editing.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
            </div>
            <div class="col-sm-3">
              <w-field SimpleDataType="Number" v-model="editing.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
            </div>
            <div class="col-sm-3">
              <w-field SimpleDataType="Number" v-model="editing.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
            </div>
            <div class="col-sm-3">
              <w-field SimpleDataType="Number" v-model="editing.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
            </div>
            <div class="col-sm-3">
              <w-field SimpleDataType="Number" v-model="editing.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
            </div>
          </div>
          <div class="">
            <label for="col-bd">Content :</label>
            <div class="row m-0 mb-3">
              <div class="col-12 col-sm-6 p-0">
                <button type="button" class="btn btn-block" :class="editing['editor'] == 'doc' ? 'btn-primary' : 'btn-white'" @click="changeEditor('doc')">Document editor</button>
              </div>
              <div class="col-12 col-sm-6 p-0">
                <button type="button" class="btn btn-block" :class="editing['editor'] == 'html' ? 'btn-primary' : 'btn-white'" @click="changeEditor('html')">HTML Editor</button>
              </div>
            </div>
            <component v-if="editing['editor'] == 'html'" is="PrismEditorMain" v-model="editing['content']"></component>
            <component v-else is="CkRichEditor" v-model="editing['content']"></component>
          </div>
        </div>
        <footer class="modal-footer modal-footer-custom">
          <button type="button" class="btn btn-light" @click="$refs.modal_edit_column.hide()">Close</button>
        </footer>
      </b-modal>

      <div class="p-3 mb-2">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.full_width" Title="Full width :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Will this section be full screen width?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section content :</h6>

      </div>

      <div class="p-2">
        <draggable handle=".colhandle" v-bind="{animation: 200}" :force-fallback="true" v-model="pc.columns">
          <transition-group tag="div" class="row m-0">
            <div v-for="(col, col_i) in pc.columns" :key="'col'+col_i" class="col-12 p-1" :class="'col-sm-'+col.width">
              <div class="border _b-dashed rounded">
                <div class="bg-light p-1">
                  <div class="float-right">
                    <button type="button" class="btn btn-sm btn-white ml-1" style="padding: 2.9px 10px;" v-tippy content="Click to delete" @click="delete_content(col_i)"><Icon icon="ri:delete-bin-7-line"></Icon></button>
                    <button type="button" class="btn btn-sm btn-white colhandle ml-1" style="padding: 2.9px 10px;" v-tippy content="Drag to rearrange"><Icon icon="ri:drag-move-2-line"></Icon></button>
                  </div>
                  <h6 class="m-2">Column</h6>
                  <div class="clearfix"></div>
                </div>
                <div class="p-3">
                  <w-field SimpleDataType="Number" v-model="col.width" Title="Width :" Min="1" Max="12"></w-field>
                  <button type="button" class="btn btn-block btn-light" @click="editing = col; $refs.modal_edit_column.show()">Edit content</button>
                </div>
              </div>
            </div>
          </transition-group>
        </draggable>
      </div>
      <div class="p-3 mt-2">
        <button type="button" class="btn btn-sm btn-primary" @click="pc.columns.push({pad_t:'',pad_r:'',pad_b:'',pad_l:'',width:'4',content:'',editor:'doc'}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add column</button>
      </div>
    </div>


    <div v-else class="m_container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div :class="(pc['full_width'] ? '' : 'container-fluid')+' pt-'+(pc['pad_t'] ? pc['pad_t'] : '0')+' pr-'+(pc['pad_r'] ? pc['pad_r'] : '0')+' pb-'+(pc['pad_b'] ? pc['pad_b'] : '0')+' pl-'+(pc['pad_l'] ? pc['pad_l'] : '0')">

        <div class="row m-0 justify-content-center">
          <div v-for="(col, col_i) in pc.columns" :key="'col'+col_i" class="col-12" :class="'col-sm-'+col['width']">
            <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(col['image'] ? fullurlencode(col['image']) : '')+')'"></div>
            <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+col['color']+' _o-'+col['opacity']"></div>
            <div :class="'pt-'+(col['pad_t'] ? col['pad_t'] : '0')+' pr-'+(col['pad_r'] ? col['pad_r'] : '0')+' pb-'+(col['pad_b'] ? col['pad_b'] : '0')+' pl-'+(col['pad_l'] ? col['pad_l'] : '0')">
              <div v-html="col['content']"></div>
            </div>
          </div>
        </div>

      </div>
    </div>


  </section>
</template>
